import React from 'react';
import { Route } from 'react-router';
import App from './containers/App';
import Workshops from './containers/Workshops';
import Workshop from './containers/Workshop';
import Projects from './containers/Projects';
import Project from './containers/Project';
import Theme from './containers/Theme';
import People from './containers/People';
import Facilitator from './containers/Facilitator';
import Location from './containers/Location';
import About from './containers/About';
import Contact from './containers/Contact';
import Support from './containers/Support';
import Happening from './containers/Happening';

export default <Route path="/:lang" component={App}>
  <Route path="/:lang/happenings/:id" component={Happening} />
  <Route path="/:lang/workshops" component={Workshops}>
    <Route path="/:lang/workshops/:id" component={Workshop} />
  </Route>
  <Route path="/:lang/projects" component={Projects}>
    <Route path="/:lang/projects/:id" component={Project} />
  </Route>
  <Route path="/:lang/theme" component={Theme} />
  <Route path="/:lang/people" component={People} >
    <Route path="/:lang/people/:id" component={Facilitator} />
  </Route>
  <Route path="/:lang/location" component={Location} />
  <Route path="/:lang/about" component={About} />
  <Route path="/:lang/support" component={Support} />
  <Route path="/:lang/contact" component={Contact} />
</Route>;



// WEBPACK FOOTER //
// ./js/routes-ar.js